import invariant from 'fbjs/lib/invariant';
import categoriesState from "./desktop/utils/categoriesState";

const debug = window.debug('entry binding');

export default MggpEPG;

/**
 *
 * @constructor
 */
function MggpEPG() {
  debug('create instance EPG');
}

/**
 * @static
 * @type {null|Object}
 */
MggpEPG.epg = null;

/**
 * @static
 * @memberOf MggpEPG
 * @type {[Function]}
 */
MggpEPG.onInitCallbacks = [];

/**
 * @static
 * @memberOf MggpEPG
 * @param {Function} cb
 */
MggpEPG.onInit = function(cb) {
  debug('add onInit handler, will call `%s` %s', cb.name, MggpEPG.epg ? 'right now' : 'postpone');
  MggpEPG.epg ?
    cb(MggpEPG.epg) :
    // для „позднего“ зажиганием
    MggpEPG.onInitCallbacks.push(cb);
};

MggpEPG.prototype.init = function(options) {

  invariant(options, 'Where are the fucked options for EPG?');
  invariant(options.player, 'What cunt squander this fucked player?');

  const {
    /** @var MggPlayer */
    player,
  } = options;

  player.registerProperty('epg:initOptions', undefined, true);
  if(!player.get('isMobile')) {
    player.registerProperty('epg:genresExpandedState', categoriesState.getAll(), true);
  }

  player.on('epg:inited', (event) => {
    debug('EPG inited');

    const { data } = event;

    MggpEPG.onInitCallbacks.forEach(cb => cb(data));

    debug('%d onInit\'s cb fired', MggpEPG.onInitCallbacks.length);

    MggpEPG.onInitCallbacks.length = 0;
    MggpEPG.epg = data;
  });

  player.set('epg:initOptions', options);
};
